import {CommonModule, NgOptimizedImage} from '@angular/common';
import {AfterViewInit, Component, OnInit} from '@angular/core';
import {RouterLink} from '@angular/router';

import * as feather from 'feather-icons';
import {TranslateModule} from "@ngx-translate/core";
import packageInfo from '../../../../package.json';
@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [
        CommonModule,
        RouterLink,
        TranslateModule,
        NgOptimizedImage
    ],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit, AfterViewInit {
  ngAfterViewInit() {
    feather.replace();
  }

  date: any

  get version(): string {
    return packageInfo.version;
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.date = new Date().getFullYear()
  }

  link1 = [];
  link2 = [
    {
      title: 'FOOTER.CONTACT_US',
      link: '/aboutus'
    },
    {
      title: 'FOOTER.NEWS',
      link: '/news'
    },
    {
      title: 'FOOTER.TERMS_OF_SERVICE',
      link: '/terms'
    },
    {
      title: 'FOOTER.PRIVACY_POLICY',
      link: '/privacy'
    },
    {
      title: 'FOOTER.REFUNDS_POLICY',
      link: '/refunds-policy'
    },
    {
      title: 'FOOTER.LOGIN',
      link: '/login'
    },
    {
      title: 'FOOTER.CONTACT_US',
      link: '/contact'
    },
  ]

  social = [
    {
      icon: 'uil uil-facebook-f',
      link: 'https://www.facebook.com/world-conquer-online'
    },
  ]
}
